import React from 'react'
import { Button } from 'reactstrap';
import { FormService } from './FormService';
import { ModalButtonSave,ModalButtonUpdate } from '../../constant';
import { DeleteService } from './DeleteService';
import { Dialog } from 'primereact/dialog';

export const ModalService = (props) => {

    const {
        modal, modalTitle, closeDialog, method, loading,
        name, handleInputChange, validaciones,
        saveCreate, saveDelete, saveUpdate
    } = props;

    const footer = (
       <>
            <Button
                color="danger"
                size="sm"
                onClick={closeDialog}
                disabled={loading}
            >
                Cancelar
            </Button>

            <Button
                color="primary"
                size="sm"
                onClick={method === "create" ? saveCreate : saveUpdate}
                disabled={loading}
                className={loading ? "progress-bar-animated progress-bar-striped" : ""}
            >
                {
                    loading
                        ? (
                            <>
                                <i className="fa fa-spinner fa-spin mr-2"></i>
                                Guardando...
                            </>
                        )
                        : "Confirmar"
                }
            </Button>
        </>
    );

    return (
        <Dialog 
            header={modalTitle} 
            visible={modal} 
            onHide={closeDialog} 
            closable 
            modal 
            blockScroll 
            className='medium-dialog'
            footer={footer}
        >
            {
                method === "create"
                    ? <FormService button={ModalButtonSave} {...{loading, handleInputChange, validaciones, methodAction: saveCreate }} />
                    : (method === "update")
                        ? <FormService button={ModalButtonUpdate} {...{ loading, handleInputChange, validaciones, methodAction: saveUpdate, name }} />
                        : null
            }
        </Dialog>
    )
}
